import { Box, Flex, FlexProps } from "@chakra-ui/react"
import { PAGE_BG } from "theme"
import { FCC } from "type/fcc"

// Полоса внизу экрана (кнопки проверки, пагинация истории): всегда под рукой,
// даже когда таблица короткая. Кладётся последним элементом в Page.
export const StickyBottomBar: FCC<FlexProps> = (props) => {
  const { children, ...flexProps } = props

  return (
    <>
      {/* Распорка: когда строк мало (например, после фильтра), полоса всё
          равно внизу экрана, а не сразу под таблицей. mt — съесть gap Page */}
      <Box flex={1} mt={-10} />

      <Flex
        w="full"
        direction="row"
        alignItems="center"
        gap={3}
        // Полоса доходит до самого края экрана — одинаково при длинной
        // таблице и при короткой. Нижний отступ Page (pb=10) мешает дважды:
        // sticky отсчитывает bottom от края без отступа (отсюда bottom=-10),
        // а последний элемент встаёт над отступом (отсюда mb=-10)
        position="sticky"
        bottom={-10}
        zIndex={2}
        mt={-6}
        mb={-10}
        pt={3}
        pb={5}
        // Фон страницы, непрозрачность 48% (7A) — как у шапки таблицы
        // (whiteAlpha.600): таблица под полосой видна размытой
        bg={`${PAGE_BG}7A`}
        backdropFilter="blur(6px)"
        borderTop="1px solid"
        borderColor="gray.200"
        {...flexProps}
      >
        {children}
      </Flex>
    </>
  )
}
